// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/holiday/components/HolidaySidePeek.module.css';
import {getHolidaySidePeeker, getHolidaySidePeekPack} from '@app/features/holiday/components/HolidaySidePeekResolvers';
import {
	type HolidaySidePeekParticle,
	SIDE_PEEK_DURATION_MS,
	SIDE_PEEK_REST_END_MS,
	SIDE_PEEK_REST_START_MS,
} from '@app/features/holiday/state/Holiday';
import {
	getHolidaySidePeekHost,
	scheduleHolidaySidePeekRestWindow,
} from '@app/features/holiday/utils/holidaySidePeekHost';
import type React from 'react';
import {useLayoutEffect} from 'react';

export function HolidaySidePeek({particle}: {particle: HolidaySidePeekParticle}): React.ReactElement | null {
	const pack = getHolidaySidePeekPack(particle.packId);
	const peeker = getHolidaySidePeeker(particle.packId, particle.peekerId);

	useLayoutEffect(() => {
		if (peeker?.overlayMemberList !== true) return;
		const host = getHolidaySidePeekHost();
		if (host == null) return;
		return scheduleHolidaySidePeekRestWindow(host, SIDE_PEEK_REST_START_MS, SIDE_PEEK_REST_END_MS);
	}, [peeker]);

	if (pack == null || peeker == null) return null;
	const Svg = peeker.Svg;
	return (
		<Svg
			aria-hidden="true"
			className={styles.stage}
			preserveAspectRatio="xMaxYMax meet"
			style={
				{
					'--side-peek-height': `${pack.heightRem}rem`,
					'--side-peek-max-width': `${pack.maxWidthPercent}%`,
					'--side-peek-max-height': `${pack.maxHeightPercent}%`,
					'--side-peek-nudge-x': `${peeker.offsetXPercent ?? 0}%`,
					'--side-peek-ms': `${SIDE_PEEK_DURATION_MS}ms`,
				} as React.CSSProperties
			}
			data-flx="holiday.holiday-layer.side-peek"
		/>
	);
}
